import * as React from 'react';
import PropTypes from 'prop-types';
import {translate} from "react-i18next";
import {Subbar, Title, PageHeader} from "ah-tools";
import {Link} from "react-router-dom";
import {ROUTE_ACCESS} from "../routes";
import {Button, Form, Icon, Segment} from "semantic-ui-react";
import {TextField} from "material-ui";
import {MIN_PASSWORD_LENGTH} from "../misc/vars";
import {IconButton} from "../extensions";

class AccessCreate extends React.Component {
	static propTypes = {
		onCreate: PropTypes.func.isRequired,
		onPush: PropTypes.func.isRequired,
		isCreating: PropTypes.bool
	};
	static defaultProps = {
		onCreate: (data) => alert('onCreate() is not implemented!'),
		onPush: (where) => alert('push() is not implemented!'),
		isCreating: false
	};
	state = {
		name: '',
		email: '',
		password: ''
	};
	
	set = (index, value = '') => this.setState({[index]: value});
	
	isValid = () => this.state.name.trim() !== '' && this.state.email.trim() !== '' && this.state.password.length >= MIN_PASSWORD_LENGTH;
	
	render() {
		const {name, email, password} = this.state;
		const {onCreate, isCreating, onPush} = this.props;
		return (
			<div>
				<PageHeader align={Subbar.ALIGN_BETWEEN}>
					<Subbar align={Subbar.ALIGN_START}>
						<Link className="ith-link" to={ROUTE_ACCESS}>
							<IconButton style={{marginRight: 10}}>
								<Icon name="chevron left" size="large"/>
							</IconButton>
						</Link>
						<Title>Admin anlegen</Title>
					</Subbar>
					<Subbar align={Subbar.ALIGN_END}>
						<Button form="create-access" loading={isCreating} disabled={!this.isValid() || isCreating} positive={true} inverted={true}>Anlegen</Button>
					</Subbar>
				</PageHeader>
				<Segment  loading={isCreating}>
					<Form id="create-access" onSubmit={() => onCreate({name, email, password}, () => onPush(ROUTE_ACCESS))}>
						<Form.Field>
							<TextField required={true} value={name} onChange={(_, value) => this.set('name', value)} hintText="Name" floatingLabelText="Name"/>
						</Form.Field>
						<Form.Field>
							<TextField required={true} type="email" value={email} onChange={(_, value) => this.set('email', value)} hintText="E-Mail" floatingLabelText="E-Mail"/>
						</Form.Field>
						<Form.Field>
							<TextField required={true} type="password" value={password} onChange={(_, value) => this.set('password', value)} minLength={MIN_PASSWORD_LENGTH} hintText="Passwort" floatingLabelText={`Passwort (min. ${MIN_PASSWORD_LENGTH} Zeichen)`}/>
						</Form.Field>
					</Form>
				</Segment>
				{/*<pre>{JSON.stringify(this.state, null, 4)}</pre>*/}
			</div>
		);
	}
}

export default translate()(AccessCreate);


// WEBPACK FOOTER //
// ./src/components/AccessCreate.js